import { SvgName } from '../app.config';

export const cast = <T>(x: T) => x;

export const castIcon = (value: string | undefined) => value as SvgName;
